import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "32",
      cy: "32",
      r: "30",
      fill: "#C00000"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "8",
      d: "m18 18 28 28m0-28L18 46"
    }, null, -1)
  ]))]))
}
export default { render: render }